import { useEffect, useState } from "react";
import useApi from "./useApi";

export interface McpServerConfig {
  id: number;
  siteId: number;
  name: string;
  description: string;
  url: string;
  apiKeyMasked: string;
  enabled: boolean;
  toolNames: string[];
  toolCount: number;
  createdAt: string;
  updatedAt: string;
  lastDiscoveredAt: string | null;
}

export default function useMcpServers() {
  const [items, setItems] = useState<McpServerConfig[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      try {
        const resp = await api.admin.get("McpServers");
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }

    fetchConfigs();
  }, [api.admin]);

  return { items, loading, setItems };
}
